const hejalfredScope = "hejalfred";
const santaScope = "santa2020";

export { hejalfredScope, santaScope };
